var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"layout-footer footer",class:_vm.getLayoutFooterBg()},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid container-p-x pb-3"},[_c('a',{staticClass:"footer-link pt-3",attrs:{"target":"_blank","href":"https://www.stratlabs.pe"}},[_vm._v("@Developed by "),_c('strong',{staticStyle:{"color":"#0E89CD"}},[_vm._v("StratLabs S.A.C.")])])])
}]

export { render, staticRenderFns }